/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmResponsesDelete } from "../../funcs/llmResponsesDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteResponseRequest$inboundSchema,
};

export const tool$llmResponsesDelete: ToolDefinition<typeof args> = {
  name: "llm-responses-delete",
  description: `Permanently delete a response and its data

Permanently deletes an agent response and all associated data.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmResponsesDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
